






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { PermissionType } from '@shared/common/types';
import ModalBox from '@/modules/core/components/ModalBox.vue';
import { userApi } from '../user.api';
import { User } from '../user';

@Component({
  components: {
    ModalBox,
  },
})
export default class UserDeleteBtn extends Vue {
  public loading = false;
  public PermissionType = PermissionType;
  public isModalActive = false;

  public get trashObjectName(): string {
    if (!this.entity) {
      return 'un utilisateur';
    }

    return `l'utilisateur ${this.entity.fullname}`
  }

  public get realEntityId(): string {
    return this.entity ? this.entity.id : this.entityId;
  }

  public get isVisible(): boolean {
    return (this as any).$can(PermissionType.deleteUser) && !this.entity.deletedAt;
  }

  @Prop()
  public entityId!: string;

  @Prop()
  public entity!: User;

  public cancel(): void {
    this.isModalActive = false;
  }

  public openModal(): void {
    this.isModalActive = true;
  }

  public async deleteEntity(): Promise<void> {
    this.loading = true;
    try {
      await userApi.delete(this.realEntityId);
      this.$emit('deleted');
      this.$buefy.snackbar.open({
        message: 'Utilisateur archivé',
        type: 'is-success',
      });
      this.isModalActive = false;
    } catch (e) {
      let errMsg = 'Erreur de suppression';

      if (
        e.response &&
        e.response.data &&
        e.response.data.code === 'USER_HAS_ACTIVE_DEVICES'
      ) {
        errMsg =
          'L\'utilisateur ne peut être archivé car il a des terminaux actifs';
      }

      this.$buefy.snackbar.open({
        message: errMsg,
        type: 'is-danger',
      });
    }
    this.loading = false;
  }
}
